import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Copyright */}
      <div className="bg-slate-900 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between text-xs text-slate-500">
          <p>&copy; 2024 Prime Estate. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-slate-400 transition-colors">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
